(function () {
  'use strict';

  const page = (window.FoxTheme && window.FoxTheme.page) || {};

  const STORAGE_KEY = 'seo_content_variants_v1';
  const MIN_IMPRESSIONS = 100; // Need this many views before declaring winner
  const VARIANT_COUNT = 3;

  function getData() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : { pages: {} };
    } catch {
      return { pages: {} };
    }
  }

  function saveData(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      console.warn('[Content Testing] Storage failed');
    }
  }

  // Generate meta description variants
  function generateVariants(baseDescription) {
    if (!baseDescription) return [];

    const variants = [baseDescription];

    if (page.template === 'product' && page.product) {
      // Product page specific data
      const productRating = page.product.reviewsRating || 0;

      // Variant 2: Add urgency
      if (baseDescription.length < 140) {
        variants.push(`${baseDescription} Order now for fast shipping!`);
      }

      // Variant 3: Add social proof
      if (productRating && productRating > 0) {
        variants.push(`⭐ ${productRating}/5 stars. ${baseDescription}`);
      } else {
        variants.push(`Popular choice. ${baseDescription}`);
      }
    } else if (page.template === 'collection') {
      // Collection variants
      variants.push(`${baseDescription} Free shipping available.`);
      variants.push(`Shop our ${baseDescription.toLowerCase()} Browse now!`);
    } else {
      // Generic variants
      variants.push(`${baseDescription} Discover more.`);
      variants.push(baseDescription.replace(/\.$/, '') + ' - CoraCreaCrafts');
    }

    return variants.slice(0, VARIANT_COUNT).map((v) => v.substring(0, 160));
  }

  // Track page impression
  function trackImpression(pageKey, variantIndex) {
    const data = getData();

    if (!data.pages[pageKey]) {
      data.pages[pageKey] = {
        variants: {},
        winner: null,
        totalImpressions: 0,
      };
    }

    if (!data.pages[pageKey].variants[variantIndex]) {
      data.pages[pageKey].variants[variantIndex] = {
        impressions: 0,
        clicks: 0,
        ctr: 0,
      };
    }

    data.pages[pageKey].variants[variantIndex].impressions++;
    data.pages[pageKey].totalImpressions++;
    saveData(data);
  }

  // Track outbound click (indicates CTR)
  function trackClick(pageKey, variantIndex) {
    const data = getData();

    if (!data.pages[pageKey] || !data.pages[pageKey].variants[variantIndex]) {
      return;
    }

    data.pages[pageKey].variants[variantIndex].clicks++;

    // Recalculate CTR
    const variant = data.pages[pageKey].variants[variantIndex];
    variant.ctr = variant.clicks / variant.impressions;

    // Check if we have enough data to declare winner
    if (data.pages[pageKey].totalImpressions >= MIN_IMPRESSIONS) {
      const variants = data.pages[pageKey].variants;
      const bestVariant = Object.entries(variants).reduce((best, [idx, v]) =>
        v.ctr > best[1].ctr ? [idx, v] : best
      );

      data.pages[pageKey].winner = parseInt(bestVariant[0]);
    }

    saveData(data);
  }

  // Select which variant to show
  function selectVariant(pageKey) {
    const data = getData();
    const pageData = data.pages[pageKey];

    // If we have a winner, always use it
    if (pageData && pageData.winner !== null) {
      return pageData.winner;
    }

    // Otherwise, rotate through variants evenly
    if (pageData) {
      const counts = Object.values(pageData.variants).map((v) => v.impressions);
      const minCount = Math.min(...counts, 0);
      const variantsWithMinCount = Object.keys(pageData.variants).filter(
        (idx) => pageData.variants[idx].impressions === minCount
      );

      if (variantsWithMinCount.length > 0) {
        return parseInt(variantsWithMinCount[0]);
      }
    }

    // New page - start with variant 0
    return 0;
  }

  // Update meta description dynamically
  function updateMetaDescription() {
    const currentMeta = document.querySelector('meta[name="description"]');
    if (!currentMeta) return;

    const baseDescription = currentMeta.getAttribute('content');
    if (!baseDescription) return;

    const pageKey = window.location.pathname;
    const variants = generateVariants(baseDescription, {});

    if (variants.length <= 1) return;

    const selectedIndex = selectVariant(pageKey);
    const selectedDescription = variants[selectedIndex] || variants[0];

    // Update the meta tag
    currentMeta.setAttribute('content', selectedDescription);

    // Track impression
    trackImpression(pageKey, selectedIndex);

    // Store variant index for click tracking
    sessionStorage.setItem('current_variant', selectedIndex);

    // Track clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link && link.hostname !== window.location.hostname) {
        const variantIndex = parseInt(sessionStorage.getItem('current_variant') || '0');
        trackClick(pageKey, variantIndex);
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMetaDescription);
  } else {
    updateMetaDescription();
  }
})();
